import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState('params', ['mobile']),
  },
  mounted() {
    if (!this.mobile) {
      setTimeout(() => {
        var myWave = wavify(document.querySelector('#footer-wave'), {
          height: 5,
          bones: 4,
          amplitude: 50,
          color: 'white',
          speed: 0.15,
        });
      }, 100);
    }
  },
};



// WEBPACK FOOTER //
// ./src/templates/components/footer/script.js